import styled from 'styled-components'
import { Image, Container, Segment } from 'semantic-ui-react'

import { BasedBodyContainer, BasedFullWidthBackgroundContainer } from '@/components/OtherCustomComponents/style'

export const BodyContainer = styled(BasedBodyContainer)`
`

export const FullWidthBackgroundContainer = styled(BasedFullWidthBackgroundContainer)`
    background-color: #e1f7f1;
    &&&:last-child {
        margin-bottom: 0;
    }
`

export const ThemedText = styled.span`
    color: #26aa86;
`

export const BodySegment = styled(Segment)`
    && {
        font-size: 1em;
        /* margin: -1em; */
    }
`

export const IconsWrapper = styled.div`
    @media (min-width: 992px) {
        padding: 1em;
    }
    &>* {
        margin-bottom: 1em;
    }
`

export const CenterText = styled.div`
    text-align: center;
`
// export const PaddedText = styled.span`
//     margin-left: 1em;
// `
export const ListItem = styled.div`
    display: flex;
    gap: 0.5em;
`
export const LeftBorderedSegmentList = styled.div`
    border-left: 3px solid #26aa86;
    padding-left: .3em;
    &~div {
        margin-top: .5em;
    }
`